import EBarResourceHeading from './EBarResourceHeading';

export default EBarResourceHeading;
